/* eslint-disable prettier/prettier */
import axios from 'axios'

export default class ApiInfo {
    async hostAndPort(){
        const response = await axios
        .get(`api/settings/api-host-and-port`);
      return response.data;
    }
}